export default __webpack_public_path__ + "static/media/TVS KING GS+ FULL_2.9f3e2bb7.webp";